<template>
  <b-modal
    id="take-materials-modal"
    dialog-class="modal-fullsize"
    hide-footer
    hide-header
    @show="onShow"
  >
    <div class="goods">
      <MaterialBrowser @selectMaterial="appendMaterial" v-if="type==='wz' || type==='pz' || type==='zpz' || type==='pmb'|| type==='sp'" />
      <MaterialSimpleBrowser
        @selectMaterial="appendMaterial"
        :constructionId="query.constructionId"
        v-else
      />
      <div class="goods-aside">
        <h2>{{title}}</h2>
        <!-- lista konstrukcji -->
        <multiselect
          v-if="issuance === true && type !== 'sp'"
          id="ajax"
          label="name"
          track-by="id"
          placeholder="Wybierz budowę"
          v-model="constructionId"
          :options="availableProjects"
          :loading="loadingConstructions"
          @select="selectConstruction"
        ></multiselect>
        <div class="goods-aside-buttons">
          <b-button variant="primary" @click="validSubmit">{{btnSubmitText}}</b-button>
          <b-button variant="danger" @click="$bvModal.hide('take-materials-modal')">Anuluj</b-button>
        </div>
        <!-- materials list -->
        <MaterialsSelectedList :type="type"
          :materials="query.materials"
          @increment="appendMaterial"
          @decrement="reduceMaterial"
          @setInput="setInput"
          @remove="removeMaterial"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MaterialBrowser from "./MaterialBrowser";
import MaterialSimpleBrowser from "./MaterialBrowser/simple";
import MaterialsSelectedList from "./MaterialsSelectedList";


export default {
  components: { MaterialBrowser, MaterialsSelectedList, MaterialSimpleBrowser },
  props: {
    issuance: Boolean,
    type: String,
    title: String,
    btnSubmitText: String
  },
  data() {
    return {
      constructionId: null,
      loadingConstructions: true,
      sign: 1,
      queryChanged: {},
      query: {
        constructionId: 0,
        materials: [],
        type: 'wz',
      }
    };
  },
  computed: {
    ...mapGetters("projectslist", ["availableProjects"]),
    ...mapGetters("materials", ["materials"])
  },
  mounted() {
    if (this.issuance === true) {
      this.loadProjects().then(() => {
        this.loadingConstructions = false;
      });
    }
  },
  methods: {
    ...mapGetters("company", ["getMainBaseCurrency"]),
    ...mapActions("projectslist", ["loadProjects"]),


    onShow() {
      this.query.materials = [];
      this.query.constructionId = 0;
      this.constructionId = null;
      this.query.type = this.type;
      if (this.type === "wz" || this.type === "zpz" || this.type === "zw") {
        this.sign = -1;
      } else {
        this.sign = 1;
      }
    },
    selectConstruction(selectedOptions) {
      if(this.type === 'zw'){
        this.query.materials = [];
      }
      this.query.constructionId = selectedOptions.id;
    },
    appendMaterial(material) {
      const storageMaterial = this.materials.find(
        ({ id }) => id == material.id
      );
      let queryMaterial = this.query.materials.find(
        ({ id }) => id == material.id
      );

      if (this.sign < 0 && storageMaterial.quantity === 0) return;

      if (!queryMaterial) {

        const materialData = {
          id: material.id,
          name: material.name,
          quantity: 1,
          price: material.price
        };

        if (this.type === 'sp') {
          materialData.margin = 0;
        }

        this.query.materials.push(materialData);



      } else {
        queryMaterial.quantity++;
      }
      const method = this.sign < 0 ? "materials/decrement" : "materials/increment";
      this.$store.commit(method, material.id);
    },
    reduceMaterial(material) {
      if (material.quantity == 0) return;
      material.quantity--;
      if (material.quantity <= 0) {
        this.removeMaterial(material);
      }
      const method =
        this.sign < 0 ? "materials/increment" : "materials/decrement";
      this.$store.commit(method, material.id);
    },
    removeMaterial(material) {
      let indexToRemove = this.query.materials.findIndex(
        ({ id }) => id == material.id
      );
      if (indexToRemove > -1) this.query.materials.splice(indexToRemove, 1);

      if (material.quantity > 0) {
        const quantity = this.sign < 0 ? material.quantity : -1 * material.quantity;
        this.$store.commit("materials/changeQuantity", {
          material_id: material.id,
          change: quantity
        });
      }
    },
    setInput(material, value) {
      const storageMaterial = this.materials.find(
        ({ id }) => id == material.id
      );
      if (this.sign < 0 && value > 0) {
        if (storageMaterial.quantity === 0) {
          //goofy force refresh
          let tmp = material.quantity;
          material.quantity -= 1;
          this.$nextTick(function() {
            material.quantity = tmp;
          });
          return;
        } else if (value > storageMaterial.quantity) {
          value = storageMaterial.quantity;
        }
      }
      material.quantity += value;
      const quantity = this.sign * value;
      this.$store.commit("materials/changeQuantity", {
        material_id: material.id,
        change: quantity
      });
      if (material.quantity <= 0) {
        this.removeMaterial(material);
      }
    },
    validSubmit() {
      if (this.issuance === true && !this.query.constructionId && this.type !== `sp`) {
        this.$store.commit("lastapimessage/push", {
          message: "Wybierz budowe",
          type: "warning"
        });
        return;
      }

      if (this.query.materials.length === 0) {
        this.$store.commit("lastapimessage/push", {
          message: "Lista wybranych materiałów nie może być pusta.",
          type: "warning"
        });
        return;
      }

      this.queryChanged = JSON.parse(JSON.stringify(this.query));

      this.queryChanged.materials.forEach(material => delete material.margin);
      if (this.type !== 'sp') {
        this.queryChanged.materials.forEach(material => delete material.price);
      }
      this.queryChanged.materials.forEach(material => {
        if (material.priceMargin > material.price) {
          delete material.price;
        }
        if (material.price === material.priceMargin) {
          delete material.priceMargin;
        }
      });


      this.$emit("submit", this.queryChanged);
    }
  }
};
</script>
